import React, { useState } from 'react'
import { useParamsInt } from '../../../../../shared/hooks/location'
import { useApiListAnalyticPeriod } from '../../../../../api-new/state/analytics'
import { useLoad } from '../../../../../shared/hooks/load'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { IconCalender } from '../../../../../shared/icon/icon'
import { VisTimelineEventPeriod } from '../vis-graph/vis-timeline-event-period'
import { Period } from '../period'
import { useTrackingMarkers } from './tracking-markers'

// The "analytic changed" markers are the record's History (audit phase 6,
// Task 19; tracking-markers.js).

export const TimelineTopic = () => {
  const { nodeID, topicID } = useParamsInt()

  const apiListAnalyticPeriod = useApiListAnalyticPeriod()

  const [selectedPeriodID, updateSelectedPeriodID] = useState()

  useLoad(() => apiListAnalyticPeriod.get(`${nodeID}/node`), [nodeID])

  const markers = useTrackingMarkers(topicID ? [{ record: `analytic_topics:${topicID}`, children: '1', recordType: 'analytics' }] : [])

  const handleLoadPeriod = () => apiListAnalyticPeriod.get(`${nodeID}/node`)

  return (
    <BreadcrumbView text="Timeline" Icon={IconCalender}>
      <CardFullHeightScrollY>
        <VisTimelineEventPeriod analytics={markers.analytics} periods={apiListAnalyticPeriod.items} onSelectPeriod={updateSelectedPeriodID} />
        <Period apiList={apiListAnalyticPeriod} selectedPeriodID={selectedPeriodID} onLoad={handleLoadPeriod} />
      </CardFullHeightScrollY>
    </BreadcrumbView>
  )
}
